import React, { useState, useEffect, useRef } from 'react';
import { IoMdSend } from "react-icons/io";
import Apiconnect from "../services/Apiconnect.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Chat = () => {
  const [message, setMessage] = useState('');
  const [chatHistory, setChatHistory] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const custId = localStorage.getItem('userId');

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const savedHistory = localStorage.getItem(`chatHistory_${custId}`);
    if (savedHistory) {
      setChatHistory(JSON.parse(savedHistory));
    }
  }, [custId]);

  useEffect(() => {
    scrollToBottom();
    console.log("Chat history updated:", chatHistory);
  }, [chatHistory]);

  useEffect(() => {
    if (custId && Object.keys(chatHistory).length > 0) {
      localStorage.setItem(`chatHistory_${custId}`, JSON.stringify(chatHistory));
    }
  }, [chatHistory, custId]);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!message.trim() || !custId) return;

    const questionTimestamp = new Date().toISOString();

    setChatHistory(prev => ({
      ...prev,
      [message]: {
        answer: "...",
        timestamp: questionTimestamp,
      }
    }));

    setMessage('');

    try {
      setIsLoading(true);
      const response = await Apiconnect.postData(`chat/${custId}`, {
        query: message
      });

      if (response.data) {
        setChatHistory(prev => ({
          ...prev,
          [message]: {
            answer: response.data.response,
            timestamp: questionTimestamp,
          }
        }));
      }
    } catch (error) {
      console.error("Chat Error:", error);
      setChatHistory(prev => ({
        ...prev,
        [message]: {
          answer: error?.response?.data?.message || 'Failed to get response',
          timestamp: questionTimestamp,
          isError: true,
        }
      }));
    } finally {
      setIsLoading(false);
    }
  };

  const clearChatHistory = () => {
    setChatHistory({});
    if (custId) {
      localStorage.removeItem(`chatHistory_${custId}`);
    }
  };

  return (
    <div className="d-flex bg-light mb-5" style={{ height: "35rem" }}>
      {/* Sidebar with fixed width */}
      <div className="bg-white border-end p-3" style={{ width: '300px', minWidth: '300px', maxWidth: '300px' }}>
        <div className="d-flex flex-column" style={{ height: '100%' }}>
          <div>
            <button className="btn btn-outline-secondary w-100 mb-3" onClick={clearChatHistory}>
              New Chat
            </button>
          </div>

          {/* Chat History */}
          <div className="overflow-auto flex-grow-1">
            <h6>Chat History:</h6>
            <ul className="list-unstyled">
              {Object.keys(chatHistory).map((question, index) => (
                <li
                  key={index}
                  className="mb-2 p-2 bg-light border rounded text-truncate"
                  style={{ cursor: 'pointer' }}
                >
                  {question}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="flex-grow-1 d-flex flex-column" style={{ overflow: 'hidden', minWidth: 0 }}>
        <div className="flex-grow-1 overflow-auto p-4">
          {Object.keys(chatHistory).length === 0 ? (
            <div className="text-muted text-center mt-5">
              Start a new chat by uploading a file and asking questions
            </div>
          ) : (
            Object.entries(chatHistory).map(([question, data], index) => (
              <React.Fragment key={index}>
                <div className="d-flex mb-3 justify-content-end">
                  <div
                    className="p-3 rounded bg-primary text-white"
                    style={{ maxWidth: '80%', wordWrap: 'break-word', overflowWrap: 'break-word' }}
                  >
                    <div>{question}</div>
                    <div className="text-end small mt-1">
                      {new Date(data.timestamp).toLocaleTimeString()}
                    </div>
                  </div>
                </div>

                <div className="d-flex mb-3 justify-content-start">
                  <div
                    className={`p-3 rounded ${data.isError ? 'bg-danger text-white' : 'bg-light'}`}
                    style={{ maxWidth: '80%', wordWrap: 'break-word', overflowWrap: 'break-word' }}
                  >
                    <div>{data.answer}</div>
                    <div className="text-end small mt-1">
                      {new Date(data.timestamp).toLocaleTimeString()}
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ))
          )}
          <div ref={messagesEndRef} />
        </div>

        {/* Input */}
        <div className="p-3 border-top bg-white">
          <form onSubmit={handleSendMessage}>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Type your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                disabled={isLoading || !custId}
              />
              <button
                className="btn btn-secondary"
                type="submit"
                disabled={isLoading || !custId || !message.trim()}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                ) : (
                  <IoMdSend size={15} />
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Chat;